import React from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";
import Home from "./pages/HomePage";
import Search from "./pages/Search";
import Chat from "./pages/Chat";
import Homepage from "./pages/HomePage";
import QualityChecker from "./pages/QualityChecker";
import DataCollection from "./pages/DataCollection";
import QualityCheckerConfigurator from "./pages/QualityCheckerConfigurator";
import ErrorPage from "./pages/ErrorPage";
import Sidebar from "./components/Sidebar/Sidebar";
import ChatPrompt from "./pages/ChatPrompt";
import AddDataCollection from "./pages/AddDataCollection";
import ProtectedLayout from "./ProtectedLayout";
import CallbackPage from "./pages/CallbackPage";
import { API_BASE_URL } from "../src/apiConfig";

const MainLayout = () => (
  <div className="app-layout">
    <Sidebar />
    <main className="content">
      <Outlet />
    </main>
  </div>
);

const router = createBrowserRouter([
  { path: "/api/auth/login", element: <CallbackPage /> },
  {
    path: "/login",
    element: <div>Redirecting to login...</div>,
    loader: () => {
      window.location.href = `${API_BASE_URL}/auth/login`;
      return null;
    },
  },
  {
    element: <ProtectedLayout />,
    children: [
      {
        path: "/",
        element: <MainLayout />,
        errorElement: <ErrorPage />,
        children: [
          { path: "/", element: <Homepage /> },
          { path: "/search", element: <Search /> },
          {
            path: "/chat",
            element: <Chat />,
            children: [
              { index: true, element: <ChatPrompt /> },
              { path: ":id", element: <ChatPrompt /> },
            ],
          },
          { path: "/data-collection", element: <DataCollection /> },
          {
            path: "/add-data-collection",
            element: <AddDataCollection />,
          },
          {
            path: "/edit-data-collection",
            element: <AddDataCollection />,
          },
        ],
      },
    ],
  },
]);

export default router;
